import { formatRelativeTime } from '../../utils/time';
/** History meta suffix per version source (WRT-04 §6). */ const SOURCE_SUFFIX = {
    assist: ' · Assist',
    restore: ' · restored',
    import: ' · imported',
    promote: ' · from a draft',
    migration: ' · moved in'
};
export function versionSourceSuffix(source) {
    return source && SOURCE_SUFFIX[source] || '';
}
/** Human words for a version source in the reload banners ("Assist", "a restore"). */ export function versionSourceWords(source) {
    switch(source){
        case 'assist':
            return 'Assist';
        case 'restore':
            return 'a restore';
        case 'import':
            return 'an import';
        case 'promote':
            return 'a draft';
        case 'migration':
            return 'a migration';
        case 'system':
        case 'adoption':
            return 'Specra';
        default:
            return 'the editor';
    }
}
export function timestampToDate(ts) {
    if (!ts) return undefined;
    try {
        return ts.toDate();
    } catch  {
        return undefined;
    }
}
export function relative(date) {
    if (!date || Number.isNaN(date.getTime())) return '';
    return formatRelativeTime(date.toISOString());
}
/** "22 Oct" */ export function shortDate(date) {
    if (!date || Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short'
    });
}
/**
 * The action bar status (F2): "v14 · saved just now", "v14 · saving…",
 * "Alternate draft · not in the package", "Read-only".
 */ export function statusText(input) {
    if (input.viewing) return 'Read-only';
    if (input.alternate) return 'Alternate draft · not in the package';
    const v = input.current?.versionNumber ? `v${input.current.versionNumber}` : '';
    if (input.saveState === 'dirty' || input.saveState === 'saving') {
        return v ? `${v} · saving…` : 'saving…';
    }
    if (input.savedAt) {
        const when = relative(input.savedAt);
        return v ? `${v} · saved ${when}` : `saved ${when}`;
    }
    return v;
}
